.card {
    background-color: var(--dib-surface);
    border-radius: 0;
    padding: var(--mantine-spacing-lg);
    margin-bottom: var(--mantine-spacing-md);
    width: 100%;
}

.description {
    font-size: var(--mantine-font-size-md);
    font-weight: 400;
    color: var(--dib-ink);
    margin: -8px 0 var(--mantine-spacing-md);
}

.title {
    font-size: var(--mantine-font-size-xs);
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--dib-ink);
    display: inline-flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    margin-bottom: var(--mantine-spacing-sm);
}
